import { useEffect, useRef } from 'react';
import { useConnectWallet, useCurrentAccount, useCurrentWallet } from '@mysten/dapp-kit';
import { isEnokiWallet } from '@mysten/enoki';

import { useWalletStore } from './useWalletStore';
import { WalletSliceKey } from '../types/wallet-slice.type';
import { useZkLoginWallet } from './useZkLoginWallet';

export function useActiveWalletSync(enabled: boolean = true) {
	const { currentWallet } = useCurrentWallet();
	const currentAccount = useCurrentAccount();
	const { mutateAsync: connectWallet } = useConnectWallet();
	const setWalletConnected = useWalletStore((state) => state.setWalletConnected);
	const zkLoginWallet = useZkLoginWallet();
	const enforcePreferredWalletRef = useRef(false);

	useEffect(() => {
		if (!enabled) {
			return;
		}
		if (!currentWallet || !currentAccount) {
			return;
		}

		const walletType: WalletSliceKey = isEnokiWallet(currentWallet) ? 'zkLoginWallet' : 'suiWallet';
		setWalletConnected(walletType, currentWallet, currentWallet.accounts, currentAccount);
	}, [currentAccount, currentWallet, enabled, setWalletConnected]);

	// useEffect(() => {
	// 	const shouldPrioritizeZkLogin = Boolean(zkLoginWallet.currentWallet) && (!currentWallet || !isEnokiWallet(currentWallet));

	// 	if (!shouldPrioritizeZkLogin) {
	// 		enforcePreferredWalletRef.current = false;
	// 		return;
	// 	}

	// 	if (enforcePreferredWalletRef.current) {
	// 		return;
	// 	}

	// 	enforcePreferredWalletRef.current = true;

	// 	const accountAddress = zkLoginWallet?.currentAccount?.address ?? zkLoginWallet?.accounts?.[0]?.address;

	// 	void connectWallet({
	// 		wallet: zkLoginWallet.currentWallet!,
	// 		accountAddress,
	// 		silent: true,
	// 	})
	// 		.catch((error) => {
	// 			console.warn('Failed to prioritize zkLogin wallet', error);
	// 		})
	// 		.finally(() => {
	// 			enforcePreferredWalletRef.current = false;
	// 		});
	// }, [connectWallet, currentWallet, zkLoginWallet?.accounts, zkLoginWallet?.currentAccount?.address, zkLoginWallet.currentWallet]);
}
